import { LabelProps, Label } from './Label';
export function LabelBodyHeadline(props: LabelProps) {
    return <Label variant="text-body-headline" {...props} />;
}
